<template>
  <WdsText class="tw-truncate" :text="date" :data-test="`supplier-linked-at-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const SupplierLinkedAtColumn = graphql(`
  fragment SupplierLinkedAtColumn on SupplierClient {
    id
    createdAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof SupplierLinkedAtColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(SupplierLinkedAtColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
const { date } = useDate(computed(() => column.value.createdAt))
</script>
